/**
 * MediLink spacing, radii, and layout tokens
 */

export const spacing = {
  0: "0",
  1: "0.25rem",
  2: "0.5rem",
  3: "0.75rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  8: "2rem",
  10: "2.5rem",
  12: "3rem",
  16: "4rem",
  18: "4.5rem",
  22: "5.5rem",
};

export const radius = {
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  card: "1rem",
  cardLg: "1.25rem",
  cardXl: "1.5rem",
  full: "9999px",
};

export const layout = {
  sidebarExpanded: "17rem",   // 272px
  sidebarCollapsed: "5rem",     // 80px
  bottomNavHeight: "4rem",
  mobileHeaderHeight: "3.5rem",
  fabSize: "3.5rem",
  fabOffset: "5.5rem",
  contentMaxWidth: {
    sm: "40rem",
    md: "48rem",
    lg: "64rem",
    xl: "80rem",
    full: "100%",
  },
  modalMaxWidth: {
    sm: "24rem",
    md: "32rem",
    lg: "48rem",
    xl: "64rem",
  },
};

export const zIndex = {
  dropdown: 40,
  sticky: 45,
  overlay: 50,
  modal: 55,
  sheet: 56,
  toast: 9999,
};
